export function mergeStateObject(
		setter,
		object,
) {
	setter((prevState) => ({
	...prevState,
	...object,
}));
}